export default "__VITE_ASSET__81707ef6__"